import { useState } from 'react';
import DocumentListRows from './DocumentListRows.jsx';
import { getAircraftDocuments } from '@/services/document-list.service.js';
import { formatTail } from '@/lib/format.js';

// ONE AIRCRAFT'S DOCUMENTS (paperwork-1 D8, L1b-B3): the documents whose own moment names this tail (the server's rule:
// an aircraft swapped out keeps its earlier documents, the new one does not inherit them). Hosted on the deal page's fleet
// row and the account page's aircraft card. Read when the broker asks (the button), never on page load.
export default function AircraftDocuments({ tail }) {
  const [state, setState] = useState({ open: false, loading: false, rows: null, error: null });
  const label = formatTail(tail);
  const load = async () => {
    setState({ open: true, loading: true, rows: null, error: null });
    try {
      const r = await getAircraftDocuments(tail);
      setState({ open: true, loading: false, rows: r?.documents || [], error: null });
    } catch (e) {
      setState({ open: true, loading: false, rows: null, error: e?.body?.error || e?.message || 'the server did not answer' });
    }
  };
  const show = () => (state.open ? setState((s) => ({ ...s, open: false })) : load());
  return (
    <div className="basis-full" data-aircraft-documents={tail}>
      <button type="button" onClick={show} aria-expanded={state.open}
        className="text-[11px] text-info hover:text-accent">
        {state.open ? `Hide the documents for ${label}` : `Show the documents for ${label}`}
      </button>
      {state.open ? (
        <div className="mt-1 rounded-card bg-bg/40 px-2">
          {state.loading ? <p className="py-1.5 text-xs text-text-dim">Reading the documents for {label}...</p> : null}
          {state.error ? (
            <p className="flex flex-wrap items-center gap-2 py-1.5 text-xs text-warning">
              <span>Could not read the documents for {label}: {state.error}</span>
              <button type="button" onClick={load} className="rounded-md border border-border-strong px-2 py-0.5 text-[11px] text-text hover:bg-surface-strong">Read them again</button>
            </p>
          ) : null}
          {state.rows ? <DocumentListRows rows={state.rows} showPolicy empty={`No documents name ${label}.`} /> : null}
        </div>
      ) : null}
    </div>
  );
}
